import { useRegister } from "./RegisterContext";
import { useTranslation } from "react-i18next";



export default function FanVerification() {
    const {
        verificationData,
        setVerificationData,
    } = useRegister();

    const { t } = useTranslation();

    const handleFile = (e) => {
        const { name, files } = e.target;

        setVerificationData((prev) => ({
            ...prev,
            [name]: files[0],
        }));
    };

    return (
        <div className="verification-wrapper">

            <div className="verification-info-card">
                <div className="verification-badge">
                    ✓ {t("fanVerification.carrerupVerification")}
                </div>

                <h3>
                    {t("fanVerification.identityTitle")}
                </h3>

                <p>
                    {t("fanVerification.identityText")}
                </p>
            </div>

            <div className="verification-content">
                <div className="input-wrapper full-width">
                    <label className="pdf-upload-label">
                        {t("fanVerification.identity")}

                        <input
                            required
                            type="file"
                            name="own_id"
                            accept=".pdf,image/*"
                            hidden
                            onChange={handleFile}
                        />
                    </label>

                    {verificationData.own_id && (
                        <div className="pdf-selected">
                            📄 {verificationData.own_id.name}
                        </div>
                    )}
                </div>
            </div>

            <div className="verification-privacy">
                🔒 {t("fanVerification.privacy")}
            </div>

        </div>
    );
}